"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputConstructor = void 0;

var react_1 = __importStar(require("react"));

var formik_1 = require("formik");

var react_theme_components_1 = require("@suezenv/react-theme-components");

var clsx_1 = __importDefault(require("clsx"));

exports.InputConstructor = react_1.forwardRef(function (_a, ref) {
  var label = _a.label,
      placeholder = _a.placeholder,
      className = _a.className,
      info = _a.info,
      valid = _a.valid,
      changeCase = _a.changeCase,
      _b = _a.showSpecificError,
      showSpecificError = _b === void 0 ? true : _b,
      onChange = _a.onChange,
      onFocusField = _a.onFocusField,
      _c = _a.onBlur,
      onBlur = _c === void 0 ? function () {} : _c,
      props = __rest(_a, ["label", "placeholder", "className", "info", "valid", "changeCase", "showSpecificError", "onChange", "onFocusField", "onBlur"]);

  var _d = __read(formik_1.useField(props), 1),
      _e = _d[0],
      name = _e.name,
      value = _e.value;

  var _f = __read(react_1.useState(false), 2),
      changing = _f[0],
      setChanging = _f[1];

  var _g = formik_1.useFormikContext(),
      values = _g.values,
      errors = _g.errors,
      touched = _g.touched,
      handleChange = _g.handleChange,
      setFieldTouched = _g.setFieldTouched,
      validateField = _g.validateField,
      setFieldValue = _g.setFieldValue,
      validateForm = _g.validateForm;

  var classes = clsx_1.default(className);
  var error = errors[name];
  var touch = touched[name];

  var customHandleChange = function customHandleChange(e) {
    var _a = e.target,
        name = _a.name,
        value = _a.value;
    var reference = values.reference;
    setChanging(true);

    if (name.includes('iban_field_7') && value.length > 3) {
      return;
    }

    if (name.includes('iban_field_') && value.length > 4) {
      validateForm(values);
      return;
    }

    if (changeCase === 'upperCase') {
      e.target.value = value.toUpperCase();
    }

    if (changeCase === 'lowerCase') {
      e.target.value = value.toLowerCase();
    }

    if (name === 'reference') {
      var last = value.substring(value.length - 1);
      var reg = /(\d|-|\.|,)/;

      if (reg.test(last) || reference.length > value.length) {
        handleChange(e);
      }
    } else {
      handleChange(e);
    }

    if (onChange) onChange(e);
  };

  var customHandleBlur = function customHandleBlur(e) {
    var name = e.target.name;
    setFieldTouched(name, true);
    setChanging(false);
    validateField(name);
    onBlur(e);
  };

  var onPaste = function onPaste(e) {
    var name = e.target.name;

    if (name === 'iban_field_1') {
      var valuePaste = e.clipboardData.getData('Text');
      valuePaste = valuePaste.substring(0, 27);
      var splitsValues = valuePaste.match(/.{1,4}/g);
      splitsValues === null || splitsValues === void 0 ? void 0 : splitsValues.forEach(function (splitValue, index) {
        if (index < 7) {
          setFieldValue("iban_field_" + (index + 1), splitValue);
        }
      });
    }
  };

  var onFocus = function onFocus(e) {
    var name = e.target.name;

    if (name.includes('iban_field_')) {
      setFieldValue(name, '');
    }

    if (onFocusField) {
      onFocusField(e);
    }
  };

  return react_1.default.createElement("div", {
    className: classes
  }, react_1.default.createElement(react_theme_components_1.SzInput, __assign({}, props, {
    ref: ref,
    valid: valid && !changing && !error && touch,
    value: value,
    error: touch && error,
    info: info,
    label: label,
    placeholder: placeholder,
    onChange: customHandleChange,
    onPaste: onPaste,
    onBlur: customHandleBlur,
    onFocus: onFocus
  })), showSpecificError && value.length > 0 && error && touch && !changing && react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger"
  }, error));
});
exports.default = exports.InputConstructor;